import { render, staticRenderFns } from "./operations.vue?vue&type=template&id=2fca52c6&scoped=true"
import script from "./operations.vue?vue&type=script&lang=js"
export * from "./operations.vue?vue&type=script&lang=js"
import style0 from "./operations.vue?vue&type=style&index=0&id=2fca52c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca52c6",
  null
  
)

export default component.exports